// Mock data for Randallstown Panthers website

export const teamInfo = {
  name: "Randallstown Panthers",
  tagline: "Building Champions On and Off the Field",
  description: "Youth football and cheer organization dedicated to developing young athletes through discipline, teamwork, and excellence.",
  established: "2010",
  location: "Randallstown, Maryland",
  address: "9830 Winands Rd, Randallstown, MD 21133",
  email: "randallstownpanthers@gmail.com",
  phone: {
    coach_chris: "(410) 790-0783",
    coach_kenny: "(443) 823-1273"
  },
  social: {
    facebook: "https://www.facebook.com/share/1GqzW7z6xc/",
    instagram: "https://www.instagram.com/randallstownpanthersfootball"
  },
  registrationUrl: "https://libertyroadmd.myrec.com/info/activities/program_details.aspx?ProgramID=29897"
};

export const charterStatement = {
  mission: "The Randallstown Panthers organization is dedicated to providing a safe, supportive, and inclusive environment where young athletes can learn and enjoy the game of football. We are committed to fostering their physical, mental, and emotional growth, equipping them with skills for success both on and off the field.",
  coreValues: [
    {
      id: 1,
      title: "Safety & Preparation",
      description: "We ensure all kids are physically and mentally prepared through close supervision and safe, age-appropriate exercises and drills."
    },
    {
      id: 2,
      title: "Character & Teamwork",
      description: "We stress the importance of discipline, hard work, sportsmanship, and respect for others."
    },
    {
      id: 3,
      title: "Holistic Growth",
      description: "We aim to build self-esteem and develop the whole child, recognizing that each individual develops at their own pace."
    },
    {
      id: 4,
      title: "Inclusivity",
      description: "We welcome all children, regardless of their race, creed, athletic ability, or socioeconomic background."
    }
  ]
};

export const quickFacts = {
  about: [
    "Volunteer-run organization serving Randallstown and the greater community",
    "Administered through the Liberty Road Recreation and Park Council",
    "Established in 1984, previously affiliated with Pop Warner",
    "Proud member of the Mid Maryland Youth Football and Cheer League (MMYFCL)",
    "12 Championships won during our time in the MMYFCL",
    "Prepared many players for success at high school, college, and NFL levels"
  ],
  programs: [
    { name: "Tackle Football", ages: "Ages 6-14" },
    { name: "Flag Football", ages: "Ages 5-6" },
    { name: "Cheerleading", ages: "Ages 5-14" }
  ],
  coaching: [
    "All coaches are USA Football and NFHS Concussion certified",
    "All coaches have passed Baltimore County background checks",
    "Head Coaches possess, on average, 10+ years of youth football coaching experience"
  ],
  gameInfo: {
    home: "Held at Northwest Regional Park on Saturdays",
    away: "Take place in Baltimore, Howard, and Montgomery Counties"
  }
};

export const offSeasonTraining = {
  title: "Now Practicing · All Age Groups",
  tagline: "🔥 ACTIVELY RECRUITING — Every position, every age, every skill level",
  description:
    "Practice is in full swing for all age groups — football, flag, and cheer. " +
    "New players welcome any night. Come compete, connect, and build the skills that carry into the fall season.",
  schedule: {
    dates: "Ongoing — Monday through Friday",
    days: "Monday – Friday",
    time: "6:00 PM – 8:00 PM"
  },
  ageGroups: "All Ages · 5U through 14U · Tackle · Flag · Cheer",
  location: {
    name: "Randallstown High School",
    address: "4000 Offutt Rd, Randallstown, MD 21133"
  },
  details: {
    cost: "Free",
    requirements: "Wear cleats if you have them — first practice is free, no commitment needed"
  },
  recruitingBullets: [
    "New athletes welcome any weekday — walk-ups accepted",
    "No experience required — coaches meet every kid where they are",
    "Family-friendly · siblings can train together across age groups",
    "First practice is free, gear provided for tryouts"
  ],
  smsContact: {
    phone: "+14438231273",
    displayPhone: "(443) 823-1273",
    coachName: "Coach Kenny",
    prefilledMessage:
      "Hi Coach Kenny — my athlete would love to try a Panthers practice this week. Can you share the age group details?"
  }
};

export const nflFlagPartnership = {
  title: "New NFL FLAG Partnership",
  seasonDates: "April 4 - June 13, 2026",
  registrationDates: "February 3 - March 14, 2026",
  shortDescription: "Exciting news! The Randallstown Panthers are partnering with NFL FLAG to bring official NFL FLAG programs. Register between February 3 - March 14, 2026 for our season running April 4 - June 13, 2026!"
};

export const programs = [
  {
    id: 1,
    name: "Tackle Football",
    description: "Competitive tackle football program teaching fundamentals, teamwork, and sportsmanship.",
    ages: "7u, 8u, 9u, 10u, 11u, 12u, 13u",
    season: "Fall & Spring",
    features: ["Professional Coaching", "Age-Appropriate Training", "League Competition", "Character Development"]
  },
  {
    id: 2,
    name: "Flag Football",
    description: "Non-contact introduction to football fundamentals for younger players.",
    ages: "5-6 years old",
    season: "Fall",
    features: ["No Contact", "Learn Basics", "Fun Environment", "Skill Building"]
  },
  {
    id: 3,
    name: "Cheerleading",
    description: "Dynamic cheer program building confidence, athleticism, and team spirit.",
    ages: "5-14 years old",
    season: "Fall & Spring",
    features: ["Stunts & Tumbling", "Game Day Performances", "Competition Teams", "Dance & Cheer"]
  },
  {
    id: 4,
    name: "7v7 Football",
    description: "Fast-paced 7-on-7 football focusing on passing and skill positions.",
    ages: "Spring Tackle & 8th Grade Girls (Coming Soon)",
    season: "Spring",
    features: ["Skill Development", "Speed Training", "Position Specific", "Tournament Play"]
  },
  {
    id: 5,
    name: "NFL FLAG",
    description: "Official NFL FLAG football program bringing professional-level youth flag football to the Panthers.",
    ages: "Ages 5-14",
    season: "April 4 - June 13, 2026",
    features: ["Official NFL FLAG Certified", "Tournament Access", "Professional Coaching", "Official NFL Gear"]
  },
  {
    id: 6,
    name: "Girls Flag Football",
    description: "Our newest program — a fast-paced, non-contact flag football program built specifically for young women. Team-first, skill-focused, and empowering the next generation of female athletes.",
    ages: "Ages 12-14",
    season: "Fall",
    features: ["Girls-Only Roster", "No Contact", "Skill & Speed Training", "College-Track Development"],
    isNew: true
  }
];

export const registrationPricing = {
  tackle: [
    { period: "February through April", price: 220 },
    { period: "May through August 15th", price: 240 }
  ],
  flag: [
    { period: "All Registrations", price: 140 }
  ],
  girlsFlag: [
    { period: "All Registrations", price: 140 }
  ],
  cheer: [
    { period: "February through May", price: 225 },
    { period: "June through August 15th", price: 250 }
  ],
  springFlag: [
    { period: "Spring NFL FLAG (Ages 5-12)", price: 80 }
  ],
  note: "One time registration fee. Registration closes August 15th — no late registrations accepted.",
  cancellationPolicy: "***Cancelled registration (Tackle, Flag, Cheer) is subject to 25% administration fee. No refunds after 6/16/2026.***",
  // Set to a URL to display a custom flyer image; otherwise the auto-generated
  // <PricingFlyer /> component renders from the live tiers above (never drifts).
  flyerImage: null
};

export const cheerProgramInfo = {
  description: "Cheer athletes come in at all skill levels: Beginner, Intermediate and Advanced. Ages 5-14.",
  contactInfo: "If you are interested in volunteering or for more information contact us at Randallstownpanthers@gmail.com or contact Coach Chris, (410) 790-0783, or Coach Kenny, (443) 823-1273."
};

export const upcomingEvent = {
  title: "Randallstown Panthers Classic",
  subtitle: "Youth Football & Flag Jamboree",
  tagline: "COMPETE · CONNECT · NETWORK · WIN TOGETHER",
  hook: "TEAMS NEEDED · Guaranteed 3 scrimmages minimum per team!",
  date: "Saturday, August 8, 2026",
  time: "All Day Event",
  venue: "Randallstown High School",
  city: "4000 Offutt Rd, Randallstown, MD 21133",
  ageGroups: "Flag 5–6 · Contact 6–13U",
  features: [
    { emoji: "🏈", title: "Guaranteed 3 Scrimmages", subtitle: "per team, minimum" },
    { emoji: "🚩", title: "Teams Needed", subtitle: "Flag 5-6 · Contact 6-13U" },
    { emoji: "📸", title: "Media Coverage", subtitle: "Photos, video & visibility" },
  ],
  teamsCommitted: [
    "GA Gladiators (NJ)",
    "East Orange Jags (NJ)",
    "Old Town Gators (MD)",
    "D.M.E.I. Disciples (MD)",
    "KLM Cougars (MD)",
    "Columbia Ravens (MD)",
  ],
  description:
    "The Randallstown Panthers Classic is the region's premier youth football & flag showcase — bringing together elite programs from up and down the East Coast for an all-day festival of competition, culture, and community. " +
    "Every team walks away with game film, media exposure, and new connections. " +
    "Contact the coaches below to secure your spot.",
  contacts: [
    { name: "Coach Al",    phone: "(410) 215-7474" },
    { name: "Coach Kenny", phone: "(443) 823-1273" },
  ],
  email: "RandallstownPanthers@gmail.com",
  flyerImage:
    "https://customer-assets.emergentagent.com/job_c1db756d-3e00-42a6-869e-ac51c49851dc/artifacts/q0jyu1oe_Jam.png",
};

export const cheerJamboree = {
  title: "Randallstown Cheer Jamboree",
  subtitle: "Youth Cheerleading Showcase",
  tagline: "Energetic. Supportive. Non-competitive.",
  date: "August 8, 2026",
  venue: "Randallstown High School",
  city: "4000 Offutt Rd, Randallstown, MD 21133",
  intro:
    "Get ready for an energetic, supportive, and non-competitive celebration of talent. " +
    "Five spotlight moments built to lift every athlete on the floor.",
  program: [
    {
      emoji: "📣",
      step: 1,
      title: "The Grand Entrance",
      what: "Team procession with music and custom chants.",
      detail:
        "All squads march into the arena together, showcasing their unique team styles and " +
        "building maximum energy for the crowd right from the start.",
    },
    {
      emoji: "🤸‍♀️",
      step: 2,
      title: "Skill Exhibition Showcase",
      what: "Squads perform core routines.",
      detail:
        "Teams take center stage to present their primary non-competitive showcase routines " +
        "on professional blue cheer mats.",
    },
    {
      emoji: "⚡",
      step: 3,
      title: "Individual Skills Challenge",
      what: "Jump, tumble, and motion showcase.",
      detail:
        "A spotlight moment where individual athletes and small groups step up to display " +
        "technique-focused excellence.",
    },
    {
      emoji: "🎧",
      step: 4,
      title: "Mega Chant & Dance-Off",
      what: "Whole-arena cheer and dance led by our live DJ.",
      detail:
        "A high-octane, all-participant event. Every athlete on the floor learns and performs " +
        "a completely unified choreography sequence together.",
    },
    {
      emoji: "🏅",
      step: 5,
      title: "All-Hands Awards & Spirit Ceremony",
      what: "Final gathering for recognitions and special gifts.",
      detail:
        "No deductions, just celebration. Every participant is recognized on stage and special " +
        "team spirit awards / commemorative event bows are distributed.",
    },
  ],
  contacts: [
    { name: "Coach Alicia", phone: "(667) 210-0050" },
    { name: "Coach Kenny",  phone: "(443) 823-1273" },
  ],
  email: "RandallstownPanthers@gmail.com",
};

export const newsUpdates = [
  {
    id: 7,
    title: "Panthers Classic — Football, Flag & Cheer Jamboree | August 8, 2026",
    date: "2026-06-15",
    category: "Event",
    excerpt:
      "Save the date: August 8, 2026 at Randallstown High School. Youth football, flag, and a full Cheer Jamboree showcase — all in one day. Teams needed; guaranteed 3 scrimmages minimum.",
    content:
      "The inaugural Randallstown Panthers Classic lands August 8, 2026 at Randallstown High School (4000 Offutt Rd). " +
      "We're hosting a Youth Football & Flag Jamboree (Flag 5–6 and Contact 6–13u, guaranteed 3 scrimmages minimum per team) " +
      "AND a full Cheer Jamboree showcase the same day. Teams already committed include the GA Gladiators (NJ), East Orange Jags (NJ), " +
      "Old Town Gators (MD), D.M.E.I. Disciples (MD), and KLM Cougars (MD). " +
      "Football/Flag teams — contact Coach Al at (410) 215-7474 or Coach Kenny at (443) 823-1273. " +
      "Cheer squads — contact Coach Alicia at (667) 210-0050 or Coach Kenny at (443) 823-1273. " +
      "Email RandallstownPanthers@gmail.com for full registration details and the official program schedule.",
  },
  {
    id: 6,
    title: "Parents & Coaches Night Out — June 6 at Power Plant Live!",
    date: "2026-05-16",
    category: "Event",
    excerpt: "Join us Friday, June 6, 2026 from 8 PM – 2 AM at Power Plant Live! in Baltimore. $20 admission. Music, food & drinks, team bonding — celebrating our parents and coaches.",
    content: "You're invited to the Randallstown Panthers Parents & Coaches Night Out! Friday, June 6, 2026 at Power Plant Live! in Baltimore, MD from 8:00 PM to 2:00 AM. $20 admission. Music, good vibes, food & drinks, and team bonding outside the field. Stronger Together. One Team. One Family. Get your tickets on Eventbrite."
  },
  {
    id: 5,
    title: "Off-Season Conditioning Underway — Tue & Thu, 6-8 PM",
    date: "2026-05-16",
    category: "Training",
    excerpt: "Currently conducting off-season conditioning every Tuesday and Thursday from 6:00 PM – 8:00 PM at Randallstown High School. Designed to improve Football Skills, Conditioning, Strength, Speed, and Agility. Flag 7u, 8u, 9u, 10u, 11u & Cheerleading.",
    content: "Off-Season Conditioning is now in full swing! Designed to improve Football Skills, Conditioning, Strength, Speed, and Agility. Sessions are every Tuesday and Thursday from 6:00 PM – 8:00 PM at Randallstown High School (4000 Offutt Rd, Randallstown, MD 21133). Schedule: Tuesday & Thursday, 6-8 PM — age groups: Flag 7u, 8u, 9u, 10u, 11u & Cheerleading. Players are encouraged to wear cleats. See you on the field!"
  },
  {
    id: 1,
    title: "Fall 2026 Registration Opens February 15th!",
    date: "2026-02-01",
    category: "Registration",
    excerpt: "Mark your calendars! Fall 2026 registration opens February 15, 2026. Register early for the best pricing!",
    content: "Registration for our Fall 2026 season opens on February 15th, 2026. Early bird pricing is available - register before April to save! Don't miss out on this exciting season with the Randallstown Panthers."
  },
  {
    id: 2,
    title: "NEW: NFL FLAG Program Launches April 4th!",
    date: "2026-01-15",
    category: "New Program",
    excerpt: "Exciting partnership announcement! The Panthers are bringing official NFL FLAG football to our community starting April 4th, 2026.",
    content: "We're thrilled to announce our partnership with NFL FLAG! Our new program kicks off April 4th, 2026, offering official NFL FLAG certified training, tournaments, and professional coaching. Registration runs February 3 - March 14, 2026. This is an incredible opportunity for young athletes ages 5-14 to experience football at the highest youth level."
  },
  {
    id: 3,
    title: "2026 Season Schedule Coming Soon",
    date: "2026-01-10",
    category: "Schedule",
    excerpt: "The official 2026 fall season schedule has not been released yet — we'll post it here as soon as the league finalizes game dates.",
    content: "Our 2026 fall game schedule has not been released yet. Once the Mid Maryland Youth Football & Cheer League finalizes matchups, we'll publish the full schedule for all age groups right here. In the meantime, practices and off-season training will continue as planned at Randallstown HS."
  },
  {
    id: 4,
    title: "Coaches Announced for 2026 Season",
    date: "2026-01-05",
    category: "Team Updates",
    excerpt: "Meet our experienced coaching staff for the 2026 season across all divisions.",
    content: "We're proud to announce our coaching lineup for 2026. Our certified coaches bring years of experience and dedication to developing young athletes both on and off the field."
  }
];

export const schedule = [];

export const teamResults8u = [
  {
    id: 1,
    date: "2025-08-30",
    result: "W",
    score: "19-0",
    opponent: "Bowie (A)",
    location: "Away",
    venue: "White Marsh Park"
  },
  {
    id: 2,
    date: "2025-09-06",
    result: "W",
    score: "25-14",
    opponent: "HC Terps",
    location: "Home",
    venue: "Northwest Regional Park #1"
  },
  {
    id: 3,
    date: "2025-09-13",
    result: "W",
    score: "24-0",
    opponent: "301 Panthers",
    location: "Away",
    venue: "Brandywine Elementary School"
  },
  {
    id: 4,
    date: "2025-09-20",
    result: "W",
    score: "26-13",
    opponent: "WHC",
    location: "Away",
    venue: "Western Regional #4"
  },
  {
    id: 5,
    date: "2025-09-27",
    result: "W",
    score: "19-0",
    opponent: "Silver Spring",
    location: "Home",
    venue: "Northwest Regional Park #1"
  },
  {
    id: 6,
    date: "2025-10-04",
    result: "W",
    score: "13-0",
    opponent: "Pikesville Black",
    location: "Away",
    venue: "Northwest Regional Park #2"
  },
  {
    id: 7,
    date: "2025-10-11",
    result: "W",
    score: "20-0",
    opponent: "Clarksburg",
    location: "Away",
    venue: "Mattie J.T. Stepanek Park - North Field"
  },
  {
    id: 8,
    date: "2025-10-18",
    result: "W",
    score: "27-0",
    opponent: "Pikesville Purple",
    location: "Home",
    venue: "Northwest Regional Park #1"
  }
];

export const teamResults9u = [
  {
    id: 1,
    date: "2025-08-30",
    result: "W",
    score: "13-0",
    opponent: "Bowie (A)",
    location: "Away",
    venue: "White Marsh Park"
  },
  {
    id: 2,
    date: "2025-09-06",
    result: "L",
    score: "6-20",
    opponent: "HC Terps",
    location: "Home",
    venue: "Northwest Regional Park #1"
  },
  {
    id: 3,
    date: "2025-09-13",
    result: "W",
    score: "12-6",
    opponent: "Southern MD (A)",
    location: "Away",
    venue: "Laurel Springs Regional Park"
  },
  {
    id: 4,
    date: "2025-09-20",
    result: "L",
    score: "0-22",
    opponent: "WHC",
    location: "Away",
    venue: "Western Regional #4"
  },
  {
    id: 5,
    date: "2025-09-27",
    result: "W",
    score: "20-0",
    opponent: "Silver Spring",
    location: "Home",
    venue: "Northwest Regional Park #1"
  },
  {
    id: 6,
    date: "2025-10-04",
    result: "L",
    score: "7-20",
    opponent: "Pikesville",
    location: "Away",
    venue: "Northwest Regional Park #2"
  },
  {
    id: 7,
    date: "2025-10-11",
    result: "W",
    score: "6-0",
    opponent: "Baltimore Terps",
    location: "Away",
    venue: "Pimlico Field"
  },
  {
    id: 8,
    date: "2025-10-18",
    result: "W",
    score: "26-0",
    opponent: "Maplewood (A)",
    location: "Home",
    venue: "Northwest Regional Park #1"
  }
];

export const teamResults11u = [
  {
    id: 1,
    date: "2025-08-30",
    result: "W",
    score: "32-0",
    opponent: "East Howard Blue",
    location: "Away",
    venue: "Rockburn Park #5"
  },
  {
    id: 2,
    date: "2025-09-06",
    result: "W",
    score: "21-6",
    opponent: "HC Terps",
    location: "Home",
    venue: "Northwest Regional Park #1"
  },
  {
    id: 3,
    date: "2025-09-13",
    result: "L",
    score: "7-12",
    opponent: "Clarksburg",
    location: "Home",
    venue: "Western Regional #4"
  },
  {
    id: 4,
    date: "2025-09-20",
    result: "W",
    score: "20-7",
    opponent: "UNITY",
    location: "Away",
    venue: "Hillandale Local Park"
  },
  {
    id: 5,
    date: "2025-09-27",
    result: "W",
    score: "19-0",
    opponent: "Tenacity",
    location: "Home",
    venue: "Northwest Regional Park #1"
  },
  {
    id: 6,
    date: "2025-10-04",
    result: "W",
    score: "26-0",
    opponent: "East Howard Blue",
    location: "Away",
    venue: "Troy Park #2"
  },
  {
    id: 7,
    date: "2025-10-11",
    result: "W",
    score: "2-0",
    opponent: "Parkville",
    location: "Away",
    venue: "Western Regional #4"
  },
  {
    id: 8,
    date: "2025-10-18",
    result: "W",
    score: "26-0",
    opponent: "Baltimore Terps",
    location: "Home",
    venue: "Northwest Regional Park #1"
  }
];

export const teamResults13u = [
  {
    id: 1,
    date: "2025-08-30",
    result: "W",
    score: "6-0",
    opponent: "301 Panthers",
    location: "Away",
    venue: "Western Regional #5"
  },
  {
    id: 2,
    date: "2025-09-06",
    result: "W",
    score: "26-13",
    opponent: "HC Terps",
    location: "Home",
    venue: "Northwest Regional Park #1"
  },
  {
    id: 3,
    date: "2025-09-13",
    result: "W",
    score: "13-7",
    opponent: "Columbia (A)",
    location: "Away",
    venue: "Cedar Lane Park #6"
  },
  {
    id: 4,
    date: "2025-09-20",
    result: "L",
    score: "0-43",
    opponent: "WHC",
    location: "Away",
    venue: "Western Regional #4"
  },
  {
    id: 5,
    date: "2025-09-27",
    result: "W",
    score: "19-6",
    opponent: "Silver Spring",
    location: "Home",
    venue: "Northwest Regional Park #1"
  },
  {
    id: 6,
    date: "2025-10-04",
    result: "W",
    score: "13-6",
    opponent: "Pikesville (A)",
    location: "Away",
    venue: "Northwest Regional Park #2"
  },
  {
    id: 7,
    date: "2025-10-11",
    result: "W",
    score: "26-0",
    opponent: "Clarksburg",
    location: "Away",
    venue: "Mattie J.T. Stepanek Park - North Field"
  },
  {
    id: 8,
    date: "2025-10-18",
    result: "W",
    score: "25-0",
    opponent: "Middle River",
    location: "Home",
    venue: "Northwest Regional Park #1"
  }
];

export const seasonHighlights = [
  {
    id: 1,
    ageGroup: "8u",
    season: "Fall 2024",
    record: "8-0",
    achievement: "Undefeated Season",
    pointsScored: 173,
    pointsAllowed: 27,
    highlights: [
      "Perfect 8-0 regular season record",
      "5 shutout victories",
      "Outscored opponents 173-27",
      "American Division Champions"
    ]
  },
  {
    id: 2,
    ageGroup: "9u",
    season: "Fall 2024",
    record: "5-3",
    achievement: "Strong Season Finish",
    pointsScored: 84,
    pointsAllowed: 68,
    highlights: [
      "5-3 season record",
      "3 shutout victories",
      "Won final 2 games to close season strong",
      "Competitive American Division performance"
    ]
  },
  {
    id: 3,
    ageGroup: "11u",
    season: "Fall 2024",
    record: "7-1",
    achievement: "Outstanding Season",
    pointsScored: 153,
    pointsAllowed: 13,
    highlights: [
      "Impressive 7-1 season record",
      "5 shutout victories",
      "Dominant defense - only 13 points allowed",
      "American Division standout performance"
    ]
  },
  {
    id: 4,
    ageGroup: "13u",
    season: "Fall 2024",
    record: "7-1",
    achievement: "Dominant Season",
    pointsScored: 128,
    pointsAllowed: 75,
    highlights: [
      "Excellent 7-1 season record",
      "3 shutout victories",
      "Strong offensive and defensive balance",
      "American Division elite performance"
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marcus Johnson",
    role: "Parent - 10u Player",
    text: "The Panthers program has been incredible for my son. The coaches truly care about developing the whole child, not just the athlete.",
    rating: 5
  },
  {
    id: 2,
    name: "Latoya Williams",
    role: "Parent - Cheerleader",
    text: "My daughter has grown so much in confidence since joining the cheer squad. The coaches are professional and supportive.",
    rating: 5
  },
  {
    id: 3,
    name: "David Brown",
    role: "Parent - 12u Player",
    text: "Outstanding organization! They focus on fundamentals, discipline, and teamwork. My son has learned valuable life lessons here.",
    rating: 5
  }
];

export const leadershipTeam = [
  {
    id: 1,
    name: "Chris Barnes",
    title: "President",
    phone: "(410) 790-0783",
    photo: "https://customer-assets.emergentagent.com/job_c1db756d-3e00-42a6-869e-ac51c49851dc/artifacts/35oj5ldg_20512.jpg",
    bio: "Leading the Randallstown Panthers organization with dedication to youth development and community engagement."
  },
  {
    id: 2,
    name: "Randy Pack",
    title: "Vice President",
    phone: "(410) 530-5154",
    photo: "https://customer-assets.emergentagent.com/job_c1db756d-3e00-42a6-869e-ac51c49851dc/artifacts/gl7a45oi_20633.jpg",
    bio: "Supporting the organization's mission and ensuring operational excellence across all programs."
  },
  {
    id: 3,
    name: "Riah Ritter",
    title: "Director of Administration",
    phone: "(410) 979-9037",
    photo: "https://customer-assets.emergentagent.com/job_c1db756d-3e00-42a6-869e-ac51c49851dc/artifacts/d551bm8r_20634.jpg",
    bio: "Managing day-to-day operations and administrative functions to keep the organization running smoothly."
  },
  {
    id: 4,
    name: "Kenneth Mitchell",
    title: "Director of Communications",
    phone: "(443) 823-1273",
    photo: "https://customer-assets.emergentagent.com/job_c1db756d-3e00-42a6-869e-ac51c49851dc/artifacts/grqbzjvd_20534.jpg",
    bio: "Handling all communications, updates, and community outreach for the Panthers organization."
  },
  {
    id: 5,
    name: "Taylar White",
    title: "Director of Social Media",
    phone: "(443) 226-1776",
    photo: "https://customer-assets.emergentagent.com/job_c1db756d-3e00-42a6-869e-ac51c49851dc/artifacts/4n78ykyh_image0.jpeg",
    bio: "Managing the Panthers' digital presence across all social media platforms. Taylar keeps our community connected by sharing team highlights, game day moments, and behind-the-scenes content that celebrates our athletes and builds Panther pride online."
  },
  {
    id: 6,
    name: "Coach Al Lowry",
    title: "Director of Football Operations",
    phone: "(410) 215-7474",
    photo: "https://customer-assets.emergentagent.com/job_c1db756d-3e00-42a6-869e-ac51c49851dc/artifacts/rr84znfs_20631.jpg",
    bio: "Overseeing all football operations for the Randallstown Panthers — from game-day logistics and league coordination to coaching support and player development. Coach Al brings decades of grassroots football experience to keep every age group running smoothly on and off the field."
  }
];

export const coachesByAgeGroup = [
  {
    id: 1,
    ageGroup: "7u",
    headCoach: "Coach Celly",
    assistantCoaches: [],
    phone: "(443) 468-7259",
    email: "coach7u@randallstownpanthers.com",
    image: "https://customer-assets.emergentagent.com/job_57fc9b05-b88b-4200-a482-c0fddc20ac27/artifacts/w3xir55m_IMG_20260209_215249.png",
    bio: "Head Coach & Offensive Coordinator | Randallstown native & Randallstown High School Alumnus. Coach Celly leads the \"Boom Squad Boyz\" with a high-energy coaching style that transforms young athletes into a cohesive powerhouse. By emphasizing fundamentals and accountability, he fosters a culture of discipline and confidence that defines the next generation of Randallstown Panthers.",
    social: {
      instagram: "https://www.instagram.com/boomsquadboyz7u?igsh=NXJ0Z3IyM2UydHg0"
    }
  },
  {
    id: 2,
    ageGroup: "8u",
    headCoach: "Coach Nate",
    assistantCoaches: [],
    phone: "(667) 385-8431",
    image: "https://customer-assets.emergentagent.com/job_c1db756d-3e00-42a6-869e-ac51c49851dc/artifacts/bx100xng_16673.jpg",
    bio: "Head Coach | Mission: Developing character and leadership through football. Coach Nate views the football field as a classroom for life. He specializes in creating a high-standard environment that balances rigorous challenge with unwavering support. By emphasizing accountability and resilience, Coach Nate ensures that every Randallstown Panther leaves the program prepared to lead—not just in the game, but in their schools and communities."
  },
  {
    id: 3,
    ageGroup: "9u",
    headCoach: "Coach Damon",
    assistantCoaches: [],
    phone: "(443) 309-5033",
    email: "coach9u@randallstownpanthers.com",
    image: "https://customer-assets.emergentagent.com/job_c1db756d-3e00-42a6-869e-ac51c49851dc/artifacts/xb4367jv_16649.jpg",
    bio: "Head Coach | 9U Tackle Football. Coach Damon brings years of experience and a passion for developing young athletes both on and off the field.",
    social: {
      instagram: "https://www.instagram.com/randallstownpanthers9u?igsh=MXR4dzM1M213N2xrbg=="
    }
  },
  {
    id: 4,
    ageGroup: "10u",
    headCoach: "Coach B.J.",
    assistantCoaches: [],
    phone: "(443) 802-3484",
    email: "coach10u@randallstownpanthers.com",
    image: "https://customer-assets.emergentagent.com/job_57fc9b05-b88b-4200-a482-c0fddc20ac27/artifacts/gimhf5ax_9687.jpg",
    bio: "Head Coach & Defensive Coordinator | 3rd Year with Randallstown Panthers. Coach B.J. emphasizes a \"fundamentals-first\" approach rooted in discipline and accountability. Specializing in defensive strategy, he focuses on creating a smart, aggressive unit that wins through preparation and structure. Beyond the playbook, he is a dedicated mentor who uses football to teach character, respect, and the mental toughness needed for life."
  },
  {
    id: 5,
    ageGroup: "11u",
    headCoach: "Coach Pack",
    assistantCoaches: [],
    phone: "(410) 530-5145",
    email: "coach11u@randallstownpanthers.com",
    image: "https://customer-assets.emergentagent.com/job_c1db756d-3e00-42a6-869e-ac51c49851dc/artifacts/gl7a45oi_20633.jpg"
  },
  {
    id: 6,
    ageGroup: "12u",
    headCoach: "Coach Chris",
    assistantCoaches: [],
    phone: "(410) 790-0783",
    email: "coach12u@randallstownpanthers.com",
    image: "https://customer-assets.emergentagent.com/job_c1db756d-3e00-42a6-869e-ac51c49851dc/artifacts/x1bwidcc_20512.jpg",
    bio: ""
  },
  {
    id: 7,
    ageGroup: "13u",
    headCoach: "Coach Al",
    assistantCoaches: [],
    phone: "(410) 215-7474",
    email: "coach13u@randallstownpanthers.com",
    image: "https://customer-assets.emergentagent.com/job_c1db756d-3e00-42a6-869e-ac51c49851dc/artifacts/rr84znfs_20631.jpg"
  },
  {
    id: 9,
    ageGroup: "Flag - Panthers Gold 6u",
    headCoach: "Coach Corey",
    assistantCoaches: [],
    phone: "(443) 204-2515",
    email: "coachflaggold@randallstownpanthers.com",
    image: "https://customer-assets.emergentagent.com/job_c1db756d-3e00-42a6-869e-ac51c49851dc/artifacts/q6ocqobj_16950.jpg",
    bio: "Head Coach for Panthers Gold 6u Flag Team. Former player in this program and proud to be back for my 2nd season! My mission is to teach the basics, build confidence, encourage teamwork, and create a positive first football experience for every child!",
    social: {
      instagram: "https://www.instagram.com/randallstownpanthers6u?igsh=azllZ2xvcDZ2YjEx"
    }
  },
  {
    id: 11,
    ageGroup: "Girls Flag - Ages 12-14",
    headCoach: "Coach Kenny",
    assistantCoaches: [],
    phone: "(443) 823-1273",
    email: "randallstownpanthers@gmail.com",
    image: "https://customer-assets.emergentagent.com/job_c1db756d-3e00-42a6-869e-ac51c49851dc/artifacts/grqbzjvd_20534.jpg",
    bio: "Head Coach & Recruiter | Girls Flag Football (Ages 12-14). Coach Kenny is spearheading the Panthers' newest program — a girls-only, non-contact flag football team built to develop speed, football IQ, and confidence. Text or call directly to schedule a first practice; the first session is always free.",
    smsRecruit: {
      phone: "+14438231273",
      prefilledMessage: "Hi Coach Kenny — my daughter is interested in Girls Flag Football (Ages 12-14). Can you share the next practice details?"
    }
  },
  {
    id: 10,
    ageGroup: "Cheer",
    headCoach: "Coach Alicia",
    assistantCoaches: [],
    phone: "(667) 210-0050",
    email: "coachcheer@randallstownpanthers.com",
    image: "https://customer-assets.emergentagent.com/job_c1db756d-3e00-42a6-869e-ac51c49851dc/artifacts/o72k6ms1_16651.jpg",
    bio: "Cheer Squad Coach | Focus: Confidence Building, Teamwork, and Community Spirit. Coach Alicia brings a vibrant mix of energy and positivity to the Randallstown Panthers. She is committed to mentoring young athletes, helping them develop essential life skills like collaboration and resilience. Her mission is to instill a deep sense of Panther pride, ensuring every girl has the opportunity to shine in athletics and beyond.",
    social: {
      instagram: "https://www.instagram.com/randallstownpantherscheer?igsh=YjBsc2JpZmdkMHIy",
      tiktok: "https://www.tiktok.com/@randallstownpanthercheer?_r=1&_t=ZN-94SuF8SnCf0"
    }
  }
];

export const teamStore = {
  name: "Randallstown Panthers Team Store",
  url: "https://teamlocker.squadlocker.com/#/lockers/randallstown-panthers-2678261",
  description: "Get your official Randallstown Panthers gear! Shop jerseys, practice wear, fan apparel, and accessories.",
  categories: ["Jerseys", "Practice Gear", "Fan Wear", "Accessories", "Spirit Wear"],
  featuredProducts: [
    {
      id: 1,
      name: "Champion Double Dry Eco Fleece Hood",
      price: "$65.49",
      image: "https://teamlocker-cache.s3.amazonaws.com/teamlocker/stores/2678261/94430137-7afb-4b00-899f-9794d53788a5.webp",
      description: "Made with recycled polyester fibers from plastic bottles"
    },
    {
      id: 2,
      name: "Badger Youth C2 Fleece Sweatpant",
      price: "$41.34",
      image: "https://teamlocker.s3.amazonaws.com/products/5578-BK_F.png",
      description: "8 oz. Ringspun 60% cotton/40% Polyester fabric"
    },
    {
      id: 3,
      name: "Pacific Headwear Trucker Snapback",
      price: "$28.69",
      image: "https://teamlocker-cache.s3.amazonaws.com/teamlocker/stores/2678261/fcae31eb-e302-4192-95f3-aaebff09045d.webp",
      description: "The tried-and-true Trucker Snapback"
    }
  ]
};

export const paymentOptions = [
  {
    id: 1,
    name: "Affirm",
    description: "Pay over time with flexible payment plans",
    icon: "credit-card",
    available: false // Will be true when setup
  },
  {
    id: 2,
    name: "Klarna",
    description: "Buy now, pay later in installments",
    icon: "wallet",
    available: false
  },
  {
    id: 3,
    name: "Google Pay",
    description: "Quick and secure checkout with Google Pay",
    icon: "smartphone",
    available: false
  },
  {
    id: 4,
    name: "Apple Pay",
    description: "Fast, easy, and secure payment with Apple Pay",
    icon: "smartphone",
    available: false
  },
  {
    id: 5,
    name: "Zelle",
    description: "Send payment directly via Zelle",
    icon: "send",
    available: false,
    instructions: "Send to: [email/phone to be added]"
  }
];

export const faqs = [
  {
    id: 1,
    question: "What age groups do you serve?",
    answer: "We offer programs for ages 5-14: Flag Football (5-6), Girls Flag Football (12-14), Tackle Football (7u-13u), and Cheerleading (5-14)."
  },
  {
    id: 2,
    question: "When does registration open?",
    answer: "Registration typically opens in February for the fall season. Early bird pricing is available through April."
  },
  {
    id: 3,
    question: "What equipment is needed?",
    answer: "The organization provides helmets and shoulder pads. Players need to provide cleats, mouthguard, and practice gear."
  },
  {
    id: 4,
    question: "Are there tryouts?",
    answer: "No tryouts required! We welcome all skill levels and focus on development and participation."
  },
  {
    id: 5,
    question: "What is the practice schedule?",
    answer: "Practices are typically held 2-3 times per week on weekday evenings. Game days are usually on Saturdays."
  }
];